import { Gender, MemberType } from '@hc-frontend/business'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import getById from 'utils/DOM/getById'

const template = Templater(getById('template-member').innerText)
let countChild = 0

function appendMember(member, familyWrap, under15) {
  const isSpouse = member.type === MemberType.Spouse
  const isChild = member.type === MemberType.Child
  const suffix = isSpouse ? '_s' : isChild ? `${member.id.replace('child', '')}` : ''
  const node = document.createElement('div')
  let title = member.type

  if (isChild) {
    countChild += 1
    title += ` ${countChild}`
  }

  node.innerHTML = template({
    id: member.id,
    suffix,
    title,
    under15,
    summary: `${member.stringDOB} | ${member.gender === Gender.Male ? 'Male' : 'Female'}`
  })

  familyWrap.appendChild(node.firstChild)

  return suffix
}

export default appendMember
